
















































import Vue from "vue";
import Component from "vue-class-component";
import thirdPartyList from "../../../third-party-decks.json";

import { Event, ThirdPartyDeck } from "../../types";

@Component
export default class ThirdPartyDeckSelection extends Vue {
  thirdPartyList: ThirdPartyDeck[] = thirdPartyList;
  deckModel = null;
  showHelpText = false;

  onChange() {
    const currentURL = this.deckModel;
    const currentDeck = thirdPartyList.find(deck => deck.url === currentURL);

    const options = {
      title: currentDeck?.name,
      type: currentDeck?.type,
      multipleMessages: [
        {
          name: "Author",
          value: currentDeck?.author
        },
        {
          name: "Description",
          value: currentDeck?.desc
        },
        {
          name: "Type",
          value: currentDeck?.type
        }
      ],
      buttons: [
        {
          name: "Close",
          color: "indigo",
          callback: () => {
            this.deckModel = null;
          }
        }
      ]
    };

    this.$eventHub.$emit(Event.SHOW_CUSTOM_DIALOG, options);
  }

  async onDownload(url: string) {
    try {
      const response = await fetch(url);
      const fileContent = await response.json();
      this.$eventHub.$emit(Event.ADD_DECKS_FROM_JSON, fileContent, url);
    } catch (error) {
      this.$eventHub.$emit(
        Event.SNACKBAR_EVENT,
        "An error occurred while loading the third party deck"
      );
    }

    this.deckModel = null;
  }
}
